import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';

import { BaseOutlineParagraphProps } from '../OutlineParagraphPlugin.types';
import { defaultIsEmptyText, EditorPlaceHolder } from './EditorPlaceHolder';

const Main = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: 0;
  margin-bottom: 12px;
`;

interface OutlineParagraphTitleProps extends BaseOutlineParagraphProps {}

export const OutlineParagraphTitle = (props: OutlineParagraphTitleProps) => {
  const { attributes, children, element, isReadOnly } = props;

  return (
    <Main
      {...attributes}
      className={cl(
        'outline-paragraph-title-element',
        'font-inter',
        'outline-paragraph-title-text',
        element.id
      )}
    >
      <EditorPlaceHolder
        isEmptyText={() => {
          return defaultIsEmptyText(element);
        }}
        placeholderClassName="font-inter outline-paragraph-title-text"
        isReadOnly={isReadOnly}
        placeHolderText="Insert Paragraph Title Here..."
      >
        {children}
      </EditorPlaceHolder>
    </Main>
  );
};
